// The move rule (ADR-068 §2 — bytes never move, the key and the born-on facts
// never change; a move re-points the typed LINK row): a document may take every
// road (a folder here · another site · an asset); MEDIA move by their BIRTH —
// a photo born on an ASSET may go to another asset or up to a site (a
// wrong-asset upload is a mis-anchored file: reclassifying writes subjects and
// cannot re-point the link), a photo born on a SITE only to another site (an
// asset is its classification, never a move); a capture none (its ticket is
// its place). One rule, both ends.
export const MOVE_ROADS = ['folder', 'site', 'asset'];
export function moveRoadsFor(file) {
    if (file.isCapture)
        return [];
    // A filed thing on a site or an asset takes every road; on any other anchor
    // (a model's paper, later a person's or the project's) it stays where it is —
    // only its folder may change (the anchor IS its identity).
    if (file.folder !== null)
        return file.anchorKind === 'site' || file.anchorKind === 'asset' ? ['folder', 'site', 'asset'] : ['folder'];
    // Media move by BIRTH — and only site/asset media have roads at all: a photo
    // on any other anchor (a person's, the project's) has no folder to change and
    // no road to take (its anchor IS its place; the move machinery only re-points
    // site_files/asset_files rows, so any other kind here would strand the old link).
    if (file.anchorKind === 'asset')
        return ['asset', 'site'];
    return file.anchorKind === 'site' ? ['site'] : [];
}
